import { useCallback } from 'react';
import { useAsyncFn } from 'react-use';

import { PromiseVoidFunction, useBoolean } from '@dreryk/react-common';
import { StandardSpinner, TestId } from '@dreryk/react-components';

import { formsTemplatesTranslationKeys } from '../translations';

import { StyledFormsTemplateReadOnlyInsertLink } from './FormsTemplateReadOnlyInsertLink.styled';

type FormsTemplateReadOnlyInsertLinkProps = {
   readonly testId: TestId;
   readonly onClick: PromiseVoidFunction | VoidFunction;
};

export const FormsTemplateReadOnlyInsertLink = (props: FormsTemplateReadOnlyInsertLinkProps): JSX.Element => {
   const [{ setTrue: setClicked }, clicked] = useBoolean(false);
   const handleClick = useCallback(async () => {
      if (!clicked) {
         setClicked();
      }
      await props.onClick();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [clicked, props.onClick, setClicked]);
   const [{ loading }, handleAsyncClick] = useAsyncFn(handleClick, [handleClick]);

   if (loading) {
      return <StandardSpinner />;
   }

   return (
      <StyledFormsTemplateReadOnlyInsertLink
         testId={props.testId}
         disabled={clicked}
         onClick={handleAsyncClick}
         label={clicked ? formsTemplatesTranslationKeys.inserted : formsTemplatesTranslationKeys.insert}
      />
   );
};
